module.exports = __webpack_public_path__ + "static/media/success_sharing.a47a1c8b.png";